import { validateQueryParams } from '../../utils/api/api-utils';
import {
  doGetQCXRequest,
  doPostQCXRequest,
  doPutQCXActivateRequest,
  doPutQCXInactivateRequest,
  doPutQCXRequest,
} from '../../utils/api/domain/domain-api-utils';
import { FILTER_ENDPOINT, VIA_DE_TRANSPORTE } from '../../utils/api/domain/domain-endpoint-utils';

export async function fetchAll() {
  return doGetQCXRequest([
    VIA_DE_TRANSPORTE
  ]);
}
export async function fetchByFilter(params = []) {
  const validatedParams = validateQueryParams(params);
  if (validatedParams.length) {
    return doGetQCXRequest([
      VIA_DE_TRANSPORTE, FILTER_ENDPOINT
    ], validatedParams);
  }
  return { data: [] };
}

export async function fetchById(id) {
  return doGetQCXRequest([
    VIA_DE_TRANSPORTE,
    id
  ]);
}

export async function register(data) {
  return doPostQCXRequest(
    [VIA_DE_TRANSPORTE],
    data
  );
}

export async function save(data) {
  return doPutQCXRequest(
    [VIA_DE_TRANSPORTE],
    data
  );
}

export async function activateById(id) {
  return doPutQCXActivateRequest(
    [VIA_DE_TRANSPORTE],
    id
  );
}

export async function inactivateById(id) {
  return doPutQCXInactivateRequest(
    [VIA_DE_TRANSPORTE],
    id
  );
}
